import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="main-footer">
      <div className="footer">
        <div>
          <img src="/assets/images/twitter.png" alt="twitter" />
        </div>
        <div>
          <img src="/assets/images/telegram.png" alt="telegram" />{" "}
        </div>
        <div>
          <img src="/assets/images/twitter.png" alt="twitter" />
        </div>
        <div>
          <img src="/assets/images/telegram.png" alt="telegram" />
        </div>
        <div onClick={scrollToTop}>
          <h2>TO THE TOP</h2>
          <img src="/assets/images/top.png" alt="top" />
        </div>
      </div>
      <div className=" row    px-4 px-md-5 mt-4">
        <div className="col-lg-4">
          <p>Cosmic Network All Rights Reserved @2024</p>
        </div>
        <div className="col-lg-4 col-6">
          <Link to="/privacy-policy">
            <p>Privacy Policy</p>
          </Link>
        </div>
        <div className="col-lg-4  col-6">
          <p>Terms & Condition</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
